import { useEffect } from 'react';
import { DialogTitle, Divider, DialogContent, Dialog } from '@mui/material';
import { StateDialogContext } from 'src/types/stateContext';
import { HolidayForm, Transition } from 'src/components';

export const CreateHolidayDialog = ({ isOpen, setIsOpen, userId }: StateDialogContext) => {
    useEffect(() => {
        setIsOpen(isOpen);
    }, [isOpen]);

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} TransitionComponent={Transition} keepMounted fullWidth={true} maxWidth={'md'} sx={{ textAlign: 'center' }}>
            <DialogTitle>New Holiday</DialogTitle>
            <DialogContent>
                <Divider variant="middle" />
                {isOpen && userId && <HolidayForm userId={userId} setIsOpen={setIsOpen} isOpen={isOpen} />}
            </DialogContent>
        </Dialog>
    );
};
